// extracted by mini-css-extract-plugin
export default {"serviceComboSearchSettings":"UserAddNewServiceComboComponent_serviceComboSearchSettings__te1U2","sites-column":"UserAddNewServiceComboComponent_sites-column__a2P2A"};